export default "__VITE_ASSET__D3ST5UFY__"